import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustBadges = () => {
  const badges = [
    { id: 1, icon: 'Shield', label: 'KVK Gecertificeerd', description: 'Nederlandse Kamer van Koophandel' },
    { id: 2, icon: 'Award', label: 'Erkend Installateur', description: 'Technische Unie Nederland' },
    { id: 3, icon: 'Lock', label: 'GDPR Compliant', description: 'Veilige gegevensverwerking' }
  ];

  return (
    <div className="grid grid-cols-3 gap-4">
      {badges?.map((badge) => (
        <div key={badge?.id} className="flex flex-col items-center text-center p-4" style={{ border: '1px solid #1A1A1A' }}>
          <div className="w-10 h-10 rounded flex items-center justify-center mb-3" style={{ background: 'rgba(0,229,160,0.08)' }}>
            <Icon name={badge?.icon} size={20} color="#00E5A0" />
          </div>
          <h4 className="font-body font-semibold text-xs text-white mb-1">{badge?.label}</h4>
          <p className="text-xs" style={{ color: '#555555' }}>{badge?.description}</p>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;